// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-container{display:flex;justify-content:space-between;align-items:center;width:100%}.header-title{font-weight:600}", ""]);
// Exports
module.exports = exports;
